// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Ericsson and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-notification-count-height: 15.5px;
  --theia-notification-count-width: 15.5px;
}

.notification-count-container {
  align-self: center;
  background-color: var(--theia-badge-background);
  border-radius: 20px;
  color: var(--theia-badge-foreground);
  display: flex;
  font-size: calc(var(--theia-ui-font-size0) * 0.8);
  font-weight: 500;
  height: var(--theia-notification-count-height);
  justify-content: center;
  min-width: 6px;
  padding: 0 5px;
  text-align: center;
}

.notification-count-container > .notification-count {
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/notification.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,iDAAiD;EACjD,gBAAgB;EAChB,8CAA8C;EAC9C,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Ericsson and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-notification-count-height: 15.5px;\n  --theia-notification-count-width: 15.5px;\n}\n\n.notification-count-container {\n  align-self: center;\n  background-color: var(--theia-badge-background);\n  border-radius: 20px;\n  color: var(--theia-badge-foreground);\n  display: flex;\n  font-size: calc(var(--theia-ui-font-size0) * 0.8);\n  font-weight: 500;\n  height: var(--theia-notification-count-height);\n  justify-content: center;\n  min-width: 6px;\n  padding: 0 5px;\n  text-align: center;\n}\n\n.notification-count-container > .notification-count {\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
